var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-container width-100 display-flex flex-align-center flex-row px-1"},[(_vm.iconName)?_c('InsertDataPreviewIcon',{staticClass:"mr-1",attrs:{"iconName":_vm.iconName}}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }